import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { DashboardComponent } from './dashboard/dashboard.component';
import { EmployeeMasterComponent } from './employee-master/employee-master.component';
import { AdminControlComponent } from './admin-control/admin-control.component';
import { UploadHistoryComponent } from './upload-history/upload-history.component';
import { SimpleMasterComponent } from './simple-master/simple-master.component';
import { SystemSettingsComponent } from './system-settings/system-settings.component';
import { DocumentTypeMasterComponent } from './document-type-master/document-type-master.component';
import { UploadDocumentsComponent } from './upload-documents/upload-documents.component';
import { CampaignComponent } from './campaign/campaign.component';
import { TemplateCreationComponent } from './template-creation/template-creation.component';
import { TriggerCampaignComponent } from './trigger-campaign/trigger-campaign.component';
import { ItemMasterComponent } from './item-master/item-master.component';
import { GenericMasterComponent } from './generic-master/generic-master.component';
import { UserMasterComponent } from './user-master/user-master.component';
import { RecipientListsComponent } from './recipient-lists/recipient-lists.component';
import { WaFlowsComponent } from './wa-flows/wa-flows.component';
import { ClientOnboardingComponent } from './client-onboarding/client-onboarding.component';

const routes: Routes = [
  { path: 'dashboard', component: DashboardComponent },
  { path: 'masters/employee-master', component: EmployeeMasterComponent },
  { path: 'masters/document-type-master', component: DocumentTypeMasterComponent },
  {
    path: 'masters/role-master',
    component: SimpleMasterComponent,
    data: {
      title: 'Role Master',
      subheading: 'Manage the roles available when adding employees.',
      fieldLabel: 'Role Name',
      addButtonLabel: 'Add Role',
      apiBase: 'api/v1/rolemaster',
      excelFileName: 'role-master',
      icon: 'pe-7s-id',
      employeeField: 'role',
    },
  },
  {
    path: 'masters/bu-master',
    component: SimpleMasterComponent,
    data: {
      title: 'BU Master',
      subheading: 'Manage the business units available when adding employees.',
      fieldLabel: 'BU Name',
      addButtonLabel: 'Add BU',
      apiBase: 'api/v1/bumaster',
      excelFileName: 'bu-master',
      icon: 'pe-7s-culture',
      employeeField: 'bu',
    },
  },
  {
    path: 'masters/department-master',
    component: SimpleMasterComponent,
    data: {
      title: 'Department Master',
      subheading: 'Manage the departments available when adding employees.',
      fieldLabel: 'Department Name',
      addButtonLabel: 'Add Department',
      apiBase: 'api/v1/departmentmaster',
      excelFileName: 'department-master',
      icon: 'pe-7s-note2',
      employeeField: 'department',
    },
  },
  { path: 'operations/upload-documents', component: UploadDocumentsComponent },
  { path: 'campaign', component: CampaignComponent },
  { path: 'campaign/templates', component: TemplateCreationComponent },
  { path: 'campaign/trigger', component: TriggerCampaignComponent },
  { path: 'masters/item-master', component: ItemMasterComponent },
  { path: 'masters/generic-master', component: GenericMasterComponent },
  { path: 'masters/user-master', component: UserMasterComponent },
  { path: 'campaign/recipients', component: RecipientListsComponent },
  { path: 'campaign/flows', component: WaFlowsComponent },
  { path: 'admin-control', component: AdminControlComponent },
  { path: 'admin-control/upload-history', component: UploadHistoryComponent },
  { path: 'admin-control/system-settings', component: SystemSettingsComponent },
  { path: 'admin-control/client-onboarding', component: ClientOnboardingComponent },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class PagesRoutingModule {}
